import Chip from "../../../Img/chip.png";

const ViewCardDetails = ({ cardData }) => {
  return (
    <>
      <div style={{background: cardData?.bgColor}} className="p-3 rounded-3 shadow-sm mb-3">
        <div className="hstack justify-content-between ">
          <span className="hstack gap-2 text-white">
            <img src={cardData?.icon} style={{ width: 50 }} className="me-2" alt="" />
            <h5 style={{ fontSize: 16 }} className="m-0">
              {cardData?.name}
            </h5>
          </span>
          <img src={Chip} alt="" className="chip" style={{ width: 45 }} />
        </div>

        <div className="d-flex justify-content-between mt-5 flex-end">
          <div className="text-white">
            <h6 style={{ fontSize: 10 }}>Card Number</h6>
            <h5 style={{ fontSize: 16 }} className="mt-2">
              8974 5687 1234 5678
            </h5>
            <h5 style={{ fontSize: 16 }} className="mt-4">
              Card Holder Name
            </h5>
          </div>
          <div className="text-white">
            <h6 style={{ fontSize: 10 }}>Valid Thru</h6>
            <h5 style={{ fontSize: 16 }}>03/50</h5>
            <h6 style={{ fontSize: 10 }} className="mt-4">
              CVV <span style={{ fontSize: 16 }}>123</span>
            </h6>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewCardDetails;
